import React from "react";
import styles from "./InfoBoxBlock.module.scss";
import classNames from "classnames";

export interface InfoBoxBlockProps {
  text: string;
  icon?: string;
  compact?: boolean;
  styles?: Record<string, string>;
}

export const InfoBoxBlock: React.FC<InfoBoxBlockProps> = (props: InfoBoxBlockProps) => {
  const { text, icon = "cil-info-circle", compact = false } = props;

  return (
    <div className={classNames([styles.root, [compact ? styles.compact : ""]])} style={props.styles}>
      <div className={styles.iconWrapper}>
        <i className={icon} />
      </div>
      <div className={styles.textWrapper}>
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );
};
